/**
 * An event model is realtime when it has at least one linked source in
 * event_model_event_sources.
 */
export const isRealtimeEventModel = (
  event:
    | { event_model_event_sources?: readonly unknown[] | null }
    | null
    | undefined,
): boolean => (event?.event_model_event_sources?.length ?? 0) > 0;
